export default function () {
  return {
    user: {},
    loggedIn: false,
  };
}
